const proxyAppRoutes = {
  customerScan: "customer-scan",
  getCustomerGuestId: "customer-scan/guest",
  customerQrcode: (id) => `customer-scan/qrcode/${id}`,
  prescription: "prescription",
  setDefault: "prescription/setDefault",
  vtoModels: "vto-models",
  favorites: "favorite",
  collection: "products/collection/",
  productScan: "product-scan",
  deleteAccount: (id) => `customers/${id}/delete`,
  getCustomerTokenData: "customer-scan/token",
  verifyGuestScan: "customer-scan/verify-guest-scan",
  guestScan: "customer-scan/guest-scan"
}

const proxyAppApi = {
  request: async (route, method = "GET", data, isFormData = false, isCors, headers) => {
    const params = {
      method,
      mode: !isCors ? 'no-cors' : "cors",
      credentials: 'same-origin',
      headers    
    }

    if(data && !isFormData) params["body"] = JSON.stringify(data);
    else if (data) params["body"] = data;

    const environments = {
      devqa: "proxy-qa",
      staging_and_production: "proxy"
      };
    const env = window.location.href.indexOf("dev") !== -1 ? environments.devqa : environments.staging_and_production;

    const result = await fetch(`/apps/${env}/${route}`, params);

    try{
      const json = await result.json(); 
      return json;
    }catch(e){
      return null;
    }
  },
  requestImage: async (route, method = "GET") => {
    const params = {
      method 
    }

    const environments = {
      devqa: "proxy-qa",
      staging_and_production: "proxy"
      };
    const env = window.location.href.indexOf("dev") !== -1 ? environments.devqa : environments.staging_and_production;

    const result = await fetch(`/apps/${env}/${route}`, params);

    try{
      // Convert response into a Blob
      const blob = await result.blob();
      
      // Create a URL for the Blob
      const imageUrl = URL.createObjectURL(blob);
      return imageUrl;
    }catch(e){
      return null;
    }
  }
}

export const getCustomerScan = async (customerId) => {
  if (!customerId) return

  const data = await proxyAppApi.request(`${proxyAppRoutes.customerScan}?logged_in_customer_id=${customerId}`);

  return data;
}

export const getGuestScan = async (guestId) => {
  if (!guestId) return

  const data = await proxyAppApi.request(`${proxyAppRoutes.guestScan}?guest_id=${guestId}`);

  return data;
}

export const getCustomerScanBySKU = async ({ sku, logged_in_customer_id, guest_id }) => {
  // Determine the correct parameter based on the props
  const queryParams = new URLSearchParams({
    sku,
    ...(logged_in_customer_id ? { logged_in_customer_id } : { guest_id })
  });
  const data = await proxyAppApi.request(`${proxyAppRoutes.productScan}?${queryParams}`);

  return data;
}

export const deleteAccount = async (customerId, formData) => {
  const data = await proxyAppApi.request(proxyAppRoutes.deleteAccount(customerId), "POST", formData, true);

  return data;
}

export const getCustomerQrcode = async (value) => {
  const data = await proxyAppApi.requestImage(proxyAppRoutes.customerQrcode(value));

  return data;
}

export const getCustomerTokenData = async () => {
  const data = await proxyAppApi.request(proxyAppRoutes.getCustomerTokenData);

  return data;
}

export const getPrescription = async () => {
  if (!window['customerInfo']['id']) return;

  const data = await proxyAppApi.request(proxyAppRoutes.prescription);

  return data;
}

export const setPrescription = async (formData) => {
  const data = await proxyAppApi.request(proxyAppRoutes.prescription, "POST", formData, true);

  return data;
}

export const setDefaultPrescription = async (id) => {
  const data = await proxyAppApi.request(`${proxyAppRoutes.setDefault}?prescription_id=${id}`, "POST");

  return data;
}

export const getWishlist = async () => {
  const data =  await proxyAppApi.request(`${proxyAppRoutes.favorites}?sync_topology=true`);

  if(data?.status === false
  || data?.message == "Input validation error") return {};

  return data.data;
}

export const addWishlistItemBySku = async (sku) => {
  const data = await proxyAppApi.request(`${proxyAppRoutes.favorites}`, "POST", { "sku": sku }, false, true, {'Content-Type': 'application/json'});

  if(data?.status === false
  || data?.message == "Input validation error") return;

  return data;
}

export const deleteWishlistItemBySku = async (sku) => {
  const data = await proxyAppApi.request(`${proxyAppRoutes.favorites}/variant`, "DELETE", { "sku": sku }, false, true, {'Content-Type': 'application/json'});

  if(data?.status === false
  || data?.message == "Input validation error") return;

  return data;
}

export const getCollection = async (collectionId, paramsString) => {
  const data = await proxyAppApi.request(`${proxyAppRoutes.collection}${collectionId}?${paramsString}`);

  return data;
}

export const getCustomerGuestId = async () => {
  const data = await proxyAppApi.request(proxyAppRoutes.getCustomerGuestId);

  return data;
}

export const verifyGuestScan = async (id) => {
  const data = await proxyAppApi.request(`${proxyAppRoutes.verifyGuestScan}?guest_id=${id}`);

  return data;
}

export const getVTOModels = async (sku) => {
  const data = await proxyAppApi.request(`${proxyAppRoutes.vtoModels}?sku=${sku}`);

  return data;
}